export enum ServingStatus {
  NOT_SERVING = 'NOT_SERVING',
  SERVING = 'SERVING',
}

export interface RawServingStatusApiResponse {
  status: ServingStatus;
  reasons: string[] | null;
}

export const DEFAULT_NOT_SERVING_STATUS: RawServingStatusApiResponse = {
  status: ServingStatus.NOT_SERVING,
  reasons: null,
};
